import { Reveal, Eyebrow } from "./Reveal";

const ROWS = [
  {
    id: "supply",
    num: "01",
    title: "Wholesale supply",
    body: "Peptides sourced at wholesale pricing, ready to carry your label.",
  },
  {
    id: "vials",
    num: "02",
    title: "White-label vials",
    body: "Your brand on every vial, label, and box — produced and packaged for you.",
  },
  {
    id: "storefront",
    num: "03",
    title: "Brand & website",
    body: "Logo, colors, and a custom storefront with product pages and checkout.",
  },
  {
    id: "fulfillment",
    num: "04",
    title: "3PL fulfillment",
    body: "Storage, packing, and shipping handled — orders go out without you touching a box.",
  },
];

export const Included = () => (
  <section id="included" data-testid="included-section" className="scroll-mt-24 py-20 sm:py-28" tabIndex={-1}>
    <div className="mx-auto grid w-full max-w-shell gap-12 px-5 sm:px-8 lg:grid-cols-[1fr_1.25fr] lg:gap-20">
      <Reveal className="lg:sticky lg:top-28 lg:self-start">
        <Eyebrow index="02" testId="included-eyebrow">
          What's included
        </Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-paper sm:text-4xl">
          From wholesale supply
          <br />
          to their doorstep.
        </h2>
        <p className="mt-4 max-w-sm text-base text-paper/60">
          Product, vials, brand, website, and fulfillment — the entire rundown, connected under one roof.
        </p>
      </Reveal>

      <div>
        {ROWS.map((row, i) => (
          <Reveal key={row.id} delay={i * 0.08}>
            <div
              id={row.id}
              data-testid={`included-row-${row.id}`}
              tabIndex={-1}
              className={`flex scroll-mt-32 gap-6 border-t border-white/[0.08] py-8 sm:gap-10 sm:py-9 ${
                i === ROWS.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="font-display text-lg font-extrabold text-lilac/80">{row.num}</span>
              <div>
                <h3 className="font-display text-xl font-extrabold text-paper">{row.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-paper/60">{row.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
